import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { WORK_ORDER_ATTRIBUTES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/work_order_attributes_actions';

const initialState: any = standardInitialStateGenerator([]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
